import { apiConfig } from 'config';
import { req } from 'utils/request';

const { hotel } = apiConfig;

export const getOleryInfoApi = code => req().get(hotel.getOleryInfo(code));
